import React, { Suspense, lazy } from 'react';
// import Tabs from '@mui/material/Tabs';
// import Tab from '@mui/material/Tab';
// import Typography from '@mui/material/Typography';
// import { Box } from '@mui/material';
// import Avatar from '@mui/material/Avatar';
// import SelectTemplate from './selectTemplate';
// import SignatureDetails from './signatureDetails';
// import SignatureStyles from './signatureStyles';
// import { menuIcons } from 'assets/menuIcons';
import { Switch } from './switch';
import { leftMenuAtom, leftTabValueAtom, rightMenuAtom, rightTabValueAtom } from '_state/signature';
import { useRecoilValue } from 'recoil';
import { Box } from '@mui/material';

const SelectTemplate = lazy(() => import('./selectTemplate'));
const SignatureDetails = lazy(() => import('./signatureDetails'));
const SignatureStyles = lazy(() => import('./signatureStyles'));
const SignaturePhotos = lazy(() => import('./signaturePhotos'));
const SignatureColors = lazy(() => import('./signatureColors'));
const MeetingBackgrounds = lazy(() => import('./meetingBackgrounds'));
// interface TabPanelProps {
//   children?: React.ReactNode;
//   dir?: string;
//   tab: string;
//   value: string;
// }

// function TabPanel(props: TabPanelProps) {
//   const { children, value, tab, ...other } = props;

//   return (
//     <div
//       role="tabpanel"
//       hidden={value !== tab}
//       id={`full-width-tabpanel-${tab}`}
//       aria-labelledby={`full-width-tab-${tab}`}
//       {...other}
//     >
//       {value === tab && (
//         <Box sx={{ p: 3 }}>
//           <Typography>{children}</Typography>
//         </Box>
//       )}
//     </div>
//   );
// }

// const menus = [
//   { key: 'templates', icon: 'templates', comp: <SelectTemplate /> },
//   { key: 'details', icon: 'details', comp: <SignatureDetails /> },
//   { key: 'style', icon: 'style', comp: <SignatureStyles /> },
//   // { key: "images", icon: "images", comp: <Template /> },
// ];

function SideMenu() {
  const leftMenu = useRecoilValue(leftMenuAtom);
  const rightMenu = useRecoilValue(rightMenuAtom);
  const leftTabValue = useRecoilValue(leftTabValueAtom);
  const rightTabValue = useRecoilValue(rightTabValueAtom);

  // const [value, setValue] = React.useState('templates');

  // const handleChange = (event: React.SyntheticEvent, newValue: string) => {
  //   setValue(newValue);
  // };

  return (
    <Box
      component="aside"
      sx={{ overflowY: leftMenu || rightMenu ? 'auto' : 'hidden' }}
      className="sideContainer"
    >
      <div className="px-3 py-4">
        <Suspense fallback={<></>}>
          <Switch switchCase={leftMenu ? leftTabValue : rightTabValue}>
            <SelectTemplate value="Templates" />
            <SignatureDetails value="Text" />
            <SignaturePhotos value="Photos" />
            <MeetingBackgrounds value="Backgrounds" />
            <SignatureStyles value="Design" />
            <SignatureColors value="Colors" />

            {/* <MeetingTemplateSrcTwo value="template2" />
              <MeetingTemplateSrcThree value="template3" /> */}
          </Switch>
        </Suspense>
      </div>

      {/* <Tabs value={value} onChange={handleChange} aria-label="icon tabs example">
        {menus.map((menu: any) => {
          return (
            <Tab
              value={menu.key}
              key={menu.key}
              icon={
                <Avatar
                  sx={{ width: 32, height: 32 }}
                  variant="square"
                  alt=""
                  src={menuIcons[`${menu.icon}${value === menu.key ? '-active' : ''}.svg`]}
                />
              }
              aria-label={menu.key}
            />
          );
        })}
   
      </Tabs>
      {menus.map((menu: any) => (
        <TabPanel key={menu.key} value={value} tab={menu.key}>
          {menu.comp}
        </TabPanel>
      ))} */}
      {/* <TabPanel value={value} index={0}>
        <Template />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <SignatureDetails />
      </TabPanel> */}
    </Box>
  );
}

export default SideMenu;
